/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PatientRouteImport } from './routes/_patient'
import { Route as OperatorRouteImport } from './routes/_operator'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PatientPatientAppProcedureIdIndexRouteImport } from './routes/_patient/patientApp/$procedureId/index'
import { Route as OperatorSubjectsSubjectIdProceduresProcedureIdIndexRouteImport } from './routes/_operator/subjects/$subjectId/procedures/$procedureId/index'
import { Route as OperatorSubjectsSubjectIdProceduresProcedureIdSummaryIndexRouteImport } from './routes/_operator/subjects/$subjectId/procedures/$procedureId/summary/index'
import { Route as OperatorSubjectsSubjectIdProceduresProcedureIdProcedureIndexRouteImport } from './routes/_operator/subjects/$subjectId/procedures/$procedureId/procedure/index'
import { Route as OperatorSubjectsSubjectIdProceduresProcedureIdDemoIndexRouteImport } from './routes/_operator/subjects/$subjectId/procedures/$procedureId/demo/index'

const PatientRoute = PatientRouteImport.update({
  id: '/_patient',
  getParentRoute: () => rootRouteImport,
} as any)
const OperatorRoute = OperatorRouteImport.update({
  id: '/_operator',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientPatientAppProcedureIdIndexRoute =
  PatientPatientAppProcedureIdIndexRouteImport.update({
    id: '/patientApp/$procedureId/',
    path: '/patientApp/$procedureId/',
    getParentRoute: () => PatientRoute,
  } as any)
const OperatorSubjectsSubjectIdProceduresProcedureIdIndexRoute =
  OperatorSubjectsSubjectIdProceduresProcedureIdIndexRouteImport.update({
    id: '/subjects/$subjectId/procedures/$procedureId/',
    path: '/subjects/$subjectId/procedures/$procedureId/',
    getParentRoute: () => OperatorRoute,
  } as any)
const OperatorSubjectsSubjectIdProceduresProcedureIdSummaryIndexRoute =
  OperatorSubjectsSubjectIdProceduresProcedureIdSummaryIndexRouteImport.update({
    id: '/subjects/$subjectId/procedures/$procedureId/summary/',
    path: '/subjects/$subjectId/procedures/$procedureId/summary/',
    getParentRoute: () => OperatorRoute,
  } as any)
const OperatorSubjectsSubjectIdProceduresProcedureIdProcedureIndexRoute =
  OperatorSubjectsSubjectIdProceduresProcedureIdProcedureIndexRouteImport.update(
    {
      id: '/subjects/$subjectId/procedures/$procedureId/procedure/',
      path: '/subjects/$subjectId/procedures/$procedureId/procedure/',
      getParentRoute: () => OperatorRoute,
    } as any,
  )
const OperatorSubjectsSubjectIdProceduresProcedureIdDemoIndexRoute =
  OperatorSubjectsSubjectIdProceduresProcedureIdDemoIndexRouteImport.update({
    id: '/subjects/$subjectId/procedures/$procedureId/demo/',
    path: '/subjects/$subjectId/procedures/$procedureId/demo/',
    getParentRoute: () => OperatorRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/patientApp/$procedureId': typeof PatientPatientAppProcedureIdIndexRoute
  '/subjects/$subjectId/procedures/$procedureId': typeof OperatorSubjectsSubjectIdProceduresProcedureIdIndexRoute
  '/subjects/$subjectId/procedures/$procedureId/demo': typeof OperatorSubjectsSubjectIdProceduresProcedureIdDemoIndexRoute
  '/subjects/$subjectId/procedures/$procedureId/procedure': typeof OperatorSubjectsSubjectIdProceduresProcedureIdProcedureIndexRoute
  '/subjects/$subjectId/procedures/$procedureId/summary': typeof OperatorSubjectsSubjectIdProceduresProcedureIdSummaryIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/patientApp/$procedureId': typeof PatientPatientAppProcedureIdIndexRoute
  '/subjects/$subjectId/procedures/$procedureId': typeof OperatorSubjectsSubjectIdProceduresProcedureIdIndexRoute
  '/subjects/$subjectId/procedures/$procedureId/demo': typeof OperatorSubjectsSubjectIdProceduresProcedureIdDemoIndexRoute
  '/subjects/$subjectId/procedures/$procedureId/procedure': typeof OperatorSubjectsSubjectIdProceduresProcedureIdProcedureIndexRoute
  '/subjects/$subjectId/procedures/$procedureId/summary': typeof OperatorSubjectsSubjectIdProceduresProcedureIdSummaryIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_operator': typeof OperatorRouteWithChildren
  '/_patient': typeof PatientRouteWithChildren
  '/_patient/patientApp/$procedureId/': typeof PatientPatientAppProcedureIdIndexRoute
  '/_operator/subjects/$subjectId/procedures/$procedureId/': typeof OperatorSubjectsSubjectIdProceduresProcedureIdIndexRoute
  '/_operator/subjects/$subjectId/procedures/$procedureId/demo/': typeof OperatorSubjectsSubjectIdProceduresProcedureIdDemoIndexRoute
  '/_operator/subjects/$subjectId/procedures/$procedureId/procedure/': typeof OperatorSubjectsSubjectIdProceduresProcedureIdProcedureIndexRoute
  '/_operator/subjects/$subjectId/procedures/$procedureId/summary/': typeof OperatorSubjectsSubjectIdProceduresProcedureIdSummaryIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/patientApp/$procedureId'
    | '/subjects/$subjectId/procedures/$procedureId'
    | '/subjects/$subjectId/procedures/$procedureId/demo'
    | '/subjects/$subjectId/procedures/$procedureId/procedure'
    | '/subjects/$subjectId/procedures/$procedureId/summary'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/patientApp/$procedureId'
    | '/subjects/$subjectId/procedures/$procedureId'
    | '/subjects/$subjectId/procedures/$procedureId/demo'
    | '/subjects/$subjectId/procedures/$procedureId/procedure'
    | '/subjects/$subjectId/procedures/$procedureId/summary'
  id:
    | '__root__'
    | '/'
    | '/_operator'
    | '/_patient'
    | '/_patient/patientApp/$procedureId/'
    | '/_operator/subjects/$subjectId/procedures/$procedureId/'
    | '/_operator/subjects/$subjectId/procedures/$procedureId/demo/'
    | '/_operator/subjects/$subjectId/procedures/$procedureId/procedure/'
    | '/_operator/subjects/$subjectId/procedures/$procedureId/summary/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OperatorRoute: typeof OperatorRouteWithChildren
  PatientRoute: typeof PatientRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_patient': {
      id: '/_patient'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PatientRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_operator': {
      id: '/_operator'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof OperatorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_patient/patientApp/$procedureId/': {
      id: '/_patient/patientApp/$procedureId/'
      path: '/patientApp/$procedureId'
      fullPath: '/patientApp/$procedureId'
      preLoaderRoute: typeof PatientPatientAppProcedureIdIndexRouteImport
      parentRoute: typeof PatientRoute
    }
    '/_operator/subjects/$subjectId/procedures/$procedureId/': {
      id: '/_operator/subjects/$subjectId/procedures/$procedureId/'
      path: '/subjects/$subjectId/procedures/$procedureId'
      fullPath: '/subjects/$subjectId/procedures/$procedureId'
      preLoaderRoute: typeof OperatorSubjectsSubjectIdProceduresProcedureIdIndexRouteImport
      parentRoute: typeof OperatorRoute
    }
    '/_operator/subjects/$subjectId/procedures/$procedureId/summary/': {
      id: '/_operator/subjects/$subjectId/procedures/$procedureId/summary/'
      path: '/subjects/$subjectId/procedures/$procedureId/summary'
      fullPath: '/subjects/$subjectId/procedures/$procedureId/summary'
      preLoaderRoute: typeof OperatorSubjectsSubjectIdProceduresProcedureIdSummaryIndexRouteImport
      parentRoute: typeof OperatorRoute
    }
    '/_operator/subjects/$subjectId/procedures/$procedureId/procedure/': {
      id: '/_operator/subjects/$subjectId/procedures/$procedureId/procedure/'
      path: '/subjects/$subjectId/procedures/$procedureId/procedure'
      fullPath: '/subjects/$subjectId/procedures/$procedureId/procedure'
      preLoaderRoute: typeof OperatorSubjectsSubjectIdProceduresProcedureIdProcedureIndexRouteImport
      parentRoute: typeof OperatorRoute
    }
    '/_operator/subjects/$subjectId/procedures/$procedureId/demo/': {
      id: '/_operator/subjects/$subjectId/procedures/$procedureId/demo/'
      path: '/subjects/$subjectId/procedures/$procedureId/demo'
      fullPath: '/subjects/$subjectId/procedures/$procedureId/demo'
      preLoaderRoute: typeof OperatorSubjectsSubjectIdProceduresProcedureIdDemoIndexRouteImport
      parentRoute: typeof OperatorRoute
    }
  }
}

interface OperatorRouteChildren {
  OperatorSubjectsSubjectIdProceduresProcedureIdIndexRoute: typeof OperatorSubjectsSubjectIdProceduresProcedureIdIndexRoute
  OperatorSubjectsSubjectIdProceduresProcedureIdDemoIndexRoute: typeof OperatorSubjectsSubjectIdProceduresProcedureIdDemoIndexRoute
  OperatorSubjectsSubjectIdProceduresProcedureIdProcedureIndexRoute: typeof OperatorSubjectsSubjectIdProceduresProcedureIdProcedureIndexRoute
  OperatorSubjectsSubjectIdProceduresProcedureIdSummaryIndexRoute: typeof OperatorSubjectsSubjectIdProceduresProcedureIdSummaryIndexRoute
}

const OperatorRouteChildren: OperatorRouteChildren = {
  OperatorSubjectsSubjectIdProceduresProcedureIdIndexRoute:
    OperatorSubjectsSubjectIdProceduresProcedureIdIndexRoute,
  OperatorSubjectsSubjectIdProceduresProcedureIdDemoIndexRoute:
    OperatorSubjectsSubjectIdProceduresProcedureIdDemoIndexRoute,
  OperatorSubjectsSubjectIdProceduresProcedureIdProcedureIndexRoute:
    OperatorSubjectsSubjectIdProceduresProcedureIdProcedureIndexRoute,
  OperatorSubjectsSubjectIdProceduresProcedureIdSummaryIndexRoute:
    OperatorSubjectsSubjectIdProceduresProcedureIdSummaryIndexRoute,
}

const OperatorRouteWithChildren = OperatorRoute._addFileChildren(
  OperatorRouteChildren,
)

interface PatientRouteChildren {
  PatientPatientAppProcedureIdIndexRoute: typeof PatientPatientAppProcedureIdIndexRoute
}

const PatientRouteChildren: PatientRouteChildren = {
  PatientPatientAppProcedureIdIndexRoute:
    PatientPatientAppProcedureIdIndexRoute,
}

const PatientRouteWithChildren =
  PatientRoute._addFileChildren(PatientRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OperatorRoute: OperatorRouteWithChildren,
  PatientRoute: PatientRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
